import React from 'react';
import { X, Heart, Trash2, ShoppingBag } from 'lucide-react';
import { useLojaCart } from '../../context/LojaCartContext';
import { INITIAL_PRODUCTS } from '../../services/Loja/LojaMockData';

export default function FavoritesDrawer({ onOpenProductModal }) {
  const { 
    favorites, 
    isFavoritesOpen, 
    closeFavorites, 
    toggleFavorite 
  } = useLojaCart();

  if (!isFavoritesOpen) return null;

  // Filtra produtos favoritados
  const favProducts = INITIAL_PRODUCTS.filter(p => favorites.includes(p.id));

  return (
    <div className="fixed inset-0 z-50 flex justify-end">
      
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black/70 backdrop-blur-sm transition-opacity"
        onClick={closeFavorites}
      />

      {/* Drawer Container */}
      <div 
        className="relative w-full max-w-md bg-urb-dark h-full border-l border-urb-border shadow-2xl flex flex-col z-10 animate-in slide-in-from-right duration-300"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Cabeçalho */}
        <div className="flex items-center justify-between p-5 border-b border-urb-border">
          <div className="flex items-center gap-2.5">
            <div className="w-8 h-8 rounded-lg bg-red-500/10 border border-red-500/30 flex items-center justify-center text-red-400">
              <Heart className="w-4 h-4 fill-red-400" />
            </div>
            <div>
              <h3 className="text-base font-extrabold text-white tracking-wide uppercase">
                Meus Favoritos
              </h3>
              <span className="text-xs text-urb-text-muted">
                {favorites.length} {favorites.length === 1 ? 'item salvo' : 'itens salvos'}
              </span>
            </div>
          </div>

          <button
            type="button"
            onClick={closeFavorites}
            className="w-9 h-9 rounded-full bg-urb-card-light hover:bg-white/10 text-urb-text-muted hover:text-white flex items-center justify-center transition-colors cursor-pointer"
          >
            <X className="w-4 h-4" />
          </button>
        </div>

        {/* Lista ou Vazio */}
        {favProducts.length === 0 ? (
          <div className="flex-1 flex flex-col items-center justify-center p-8 text-center space-y-4">
            <div className="w-20 h-20 rounded-full bg-urb-card flex items-center justify-center border border-urb-border text-urb-text-muted">
              <Heart className="w-8 h-8 opacity-40" />
            </div>
            <div>
              <h4 className="text-lg font-bold text-white">Sua lista está vazia</h4>
              <p className="text-xs text-urb-text-secondary mt-1 max-w-xs">
                Toque no ícone de coração nos produtos da loja para salvá-los e acompanhar lançamentos.
              </p>
            </div>
          </div>
        ) : (
          <div className="flex-1 overflow-y-auto p-5 space-y-4 no-scrollbar">
            {favProducts.map((product) => {
              const primaryImg = (product.images && product.images.length > 0)
                ? (product.images.find(i => i.is_primary)?.url || product.images[0].url || product.images[0])
                : '/images/produtos/camisa-urb.png';
              const price = product.promotional_price || product.price;

              return (
                <div 
                  key={product.id}
                  className="flex gap-3.5 p-3.5 rounded-2xl bg-urb-card border border-urb-border/70 hover:border-urb-border transition-colors items-center"
                >
                  <div className="w-16 h-16 rounded-xl bg-urb-card-light/50 p-2 flex items-center justify-center border border-urb-border/50 shrink-0">
                    <img
                      src={primaryImg}
                      alt={product.name}
                      className="w-full h-full object-contain"
                    />
                  </div>

                  <div className="flex-1 min-w-0">
                    <h4 className="text-xs font-bold text-white truncate">
                      {product.name}
                    </h4>
                    <span className="text-sm font-extrabold text-urb-primary block mt-0.5">
                      R$ {price.toFixed(2).replace('.', ',')}
                    </span>
                    <button
                      type="button"
                      onClick={() => {
                        closeFavorites();
                        if (onOpenProductModal) onOpenProductModal(product);
                      }}
                      className="inline-flex items-center gap-1.5 text-[11px] text-white hover:text-urb-primary font-bold mt-1 cursor-pointer"
                    >
                      <ShoppingBag className="w-3 h-3" />
                      <span>Ver opções</span>
                    </button>
                  </div>

                  <button
                    type="button"
                    onClick={() => toggleFavorite(product.id)}
                    className="text-urb-text-muted hover:text-red-400 p-2"
                    title="Remover dos favoritos"
                  >
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
              );
            })}
          </div>
        )}

      </div>

    </div>
  );
}
